export const APP_EVENTS_ROUTE = "/events";